var FootprintLayers = {
    TOP : "TOP",
    INNER : "INNER",
    BOTTOM : "BOTTOM",
};
module.exports = FootprintLayers;

